import React from 'react';
import { IconsPros } from './types';

/**
 * ThumbsDown Icon component
 *
 * @returns JSX.ELEMENT
 */
export const ThumbsDownIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M11.6 7.54l-.19.36c-.52 1.05-2 4-2.08 4.32-.1.4-.12 3.27-.12 3.27s-1.84 1.26-2.54-2.1c-.7-3.34.2-3.76.2-3.76l-.62.01-4.43.46c-.54.06-1.03-.4-1.1-1.03-.06-.63.33-1.18.87-1.24l1.32-.14v-.05l-1.67.18C.62 7.88.07 7.42 0 6.8a1.14 1.14 0 011-1.25l.14-.02a1.1 1.1 0 01-.88-1C.2 3.9.6 3.35 1.15 3.29l.35-.04c-.35-.13-.62-.5-.67-1-.06-.62.27-1.17.75-1.22L4.35.75C5.4.57 6.65.4 7.66.4c1.5 0 2.46.28 3.2.51.41.13.76.25 1.1.3.13 0 .18.12.18.2v5.91c0 .29-.54.14-.54.22zM13.07.8a.6.6 0 00-.59.59v6.27c0 .33.26.6.59.6h2.34a.6.6 0 00.6-.6V1.39a.6.6 0 00-.6-.6h-2.34z" />
    </svg>
  );
};
